module.exports = __webpack_public_path__ + "static/media/icon-facebook.7febcff9.svg";